import { toString } from 'lodash/fp';

import { convertFantasyInsiderPosition } from '../../utils/challengeUtils';

const decodeCrunchedLineUps = (lineUps, positions, entities, lineUpId) =>
  lineUps.map(({ Lineup: lineUp, Salary: totalSalary, Score: totalScore }) => {
    const selection = [];

    if (lineUp.find(l => toString(l.playerID) === '0')) {
      return undefined;
    }

    Object.keys(positions).forEach(pos => {
      lineUp
        .filter(p => convertFantasyInsiderPosition(p.Position) === pos)
        .forEach(({ playerID, Name, Team, Position, Salary, Points, isRemoved = false }) => {
          const isTeam = `${playerID}`.charAt(0) === 'T';
          const id = isTeam ? playerID.replace('T', '') : toString(parseInt(playerID, 10));
          const idStr = isTeam ? `TEAM_${id}` : `PLAYER_${id}`;
          const { labels, initials, insiderWarning, imageURI } =
            entities.find(e => e.idStr === idStr) || {};

          selection.push({
            id,
            idStr,
            name: Name,
            team: Team,
            position: convertFantasyInsiderPosition(Position),
            insiderPosition: Position,
            activePos: Position,
            warning: insiderWarning,
            salary: Salary,
            score: Points,
            isRemoved,
            isTeam,
            labels,
            initials,
            imageURI
          });
        });
    });

    const hasCaptainPositions = Object.keys(positions).some(pos => pos === 'CAP');

    return {
      entered: false,
      selection,
      totalSalary,
      totalScore,
      lineUpId:
        lineUpId ||
        selection
          .map(({ id, position }) => (hasCaptainPositions ? `${position}:${id}` : id))
          .sort()
          .join('-')
    };
  });

export default decodeCrunchedLineUps;
